<template>
    <div class="add-palette-row gutter nav-item-mirroring fixed-top-section">
        <a class="add-palette" @click.prevent="addPalette">
            <button class="add"></button>
            <span class="add-palette__text">Create new palette</span>
        </a>
    </div>
</template>

<script>
    import Palettes from "../../../Store/Palettes";

    export default {
        name   : "AddPaletteButton",
        methods: {
            addPalette() {
                new Palettes().createPalette();
                this.$router.push({name: 'colors'});
            }
        }

    }
</script>
